<template>
  <div class="mt-4">
    <h5 class="font-weight-bolder">Fee Billing</h5>
    <p class="text-muted">
      How students are put on a fee structure. Used by Fee Management.
    </p>

    <b-form-group label="How are bills generated?" label-class="font-weight-bold" class="mb-0">
      <small v-if="loaded && !billingMode" class="text-warning d-block mb-2">
        Not chosen yet - bills are generated from the Billing Cycle page until you pick one.
      </small>
      <b-form-radio-group :checked="billingMode" stacked :disabled="!loaded || saving" @change="saveBillingMode">
        <b-form-radio value="default">
          From the Billing Cycle page
          <small class="text-muted d-block">Students are mapped to a fee structure and bills are generated
            manually.</small>
        </b-form-radio>
        <b-form-radio value="class" class="mt-2">
          Map students by class
          <small class="text-muted d-block">Each class is assigned a fee structure. Students are mapped to it
            automatically when added to the class. Bills are still generated from the Billing Cycle page.</small>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      billingMode: null,
      loaded: false,
      saving: false,
    };
  },
  async created() {
    await this.loadBillingMode();
  },
  methods: {
    settingUrl() {
      return this.$store.getters.getAPIKey.mainAPI + `/institution/setting/fee_billing_mode`;
    },
    async loadBillingMode() {
      const response = await this.$axios.get(this.settingUrl());
      this.billingMode = response.data || null;
      this.loaded = true;
    },
    async saveBillingMode(mode) {
      const previous = this.billingMode;
      if (!confirm("Changing how bills are generated affects every new student and bill. Continue?")) {
        // Re-render the radios back to the saved value.
        this.billingMode = null;
        this.$nextTick(() => { this.billingMode = previous; });
        return;
      }

      this.saving = true;
      try {
        await this.$axios.post(this.settingUrl(), { fee_billing_mode: mode });
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to update billing mode");
      }
      // Re-read rather than trust the save - an institution with no settings
      // saved yet silently ignores the write (see Institution::setting()).
      await this.loadBillingMode();
      this.saving = false;
      if (this.billingMode === mode) {
        this.$toast.success("Billing mode updated");
      } else {
        this.$toast.error("Billing mode could not be saved for this institution");
      }
    },
  },
};
</script>
